import React, { useEffect, useState } from "react";

import { makeStyles, TableContainer, Table, Grid, TableBody, Box } from "@material-ui/core";

import { api } from "../../../../../services/api";
import { Icon } from "../../../../../components/base/Icon";

import SearchIcon from "../../../../../assets/images/icons/search.svg";
import { SearchTextField } from "../../../../../components/base/TextInput";

import { ActionButtonsGroup } from "../../../../../components/buttonsGroup/ActionButtonsGroup";
import { EnhancedTableHead } from "../../../../../components/base/Table";
import { COLORS } from "../../../../../theme/colors";
import { ByBuildingTableBuildingRows } from "./ByBuildingTableBuildingRows";

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: "bold",
  },
  tableContainer: {
    borderRadius: 8,
    maxHeight: 504,
    border: `1px solid ${COLORS.darks[0][10]}`,
    boxShadow: "none",
  },
  locationCell: {
    width: 300,
  },
  activityCell: {
    width: 340,
  },
}));

const headCells = [
  {
    id: "address",
    label: "Location",
  },
  {
    id: "type",
    label: "Sys. Type",
  },
  {
    id: "production",
    label: "Production (kWh)",
  },
  {
    id: "acc_revenue",
    label: "Acc. Revenues",
  },
  {
    id: "status",
    label: "Status",
  },
  {
    label: "Recent Activity",
  },
];

export const ByBuildingTable = ({ setId, setIsList }) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [order, setOrder] = useState("asc");
  const [requiredOrderBy, setRequiredOrderBy] = useState("address");
  const [orderBy, setOrderBy] = useState("address");

  const getData = (queryParams = "") => {
    const url = `/praas/v1/power-assets/list-by-building/${queryParams}`;
    api.get(url).then((resp) => setData(resp.data));
  };

  useEffect(() => {
    getData();
  }, []);

  const handleClick = (id) => {
    setId(id);
    setIsList(false);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let queryParams = `?ordering=`;

    if (property === "address") {
      setRequiredOrderBy(`${isAsc ? "-" : ""}${property}`);
    } else {
      queryParams += `${requiredOrderBy},`;
    }

    queryParams += `${isAsc ? "-" : ""}${property}`;

    getData(queryParams);
  };

  return (
    <div style={{ marginBottom: 30 }}>
      <Grid container alignItems="center" style={{ marginBottom: 20 }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <SearchTextField id="search" />
          <label htmlFor="search">
            <Icon src={SearchIcon} />
          </label>
        </Box>
        <ActionButtonsGroup hideIntegrateBtn />
      </Grid>
      <TableContainer className={classes.tableContainer}>
        <Table aria-label="simple table" id="power-assets-by-building">
          <EnhancedTableHead
            headCells={headCells}
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
          />
          <TableBody>
            {data.map((item) => (
              <ByBuildingTableBuildingRows
                key={item.id}
                building={item}
                onClick={(id) => {
                  handleClick(id);
                }}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
